export type GalleryCategory =
  | "All"
  | "Layouts"
  | "Roads"
  | "Green Areas"
  | "Community";

export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  title: string;
  project: string;
  category: Exclude<GalleryCategory, "All">;
  size: "normal" | "wide" | "tall";
}

export const galleryImages: GalleryImage[] = [
  {
    id: "g01",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/480a4b49-6a9c-4c98-8588-0d6e4f105164_IMG-20260421-WA0012.jpg?v=02b0ca543e1c7c29ba97821cd3f73b98",
    alt: "Urban Infra residential layout development on Sarjapur Road",
    title: "Residential Layout",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "wide",
  },
  {
    id: "g02",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/be49d623-359a-4826-afd3-a4b1ac488f6d_IMG-20260421-WA0011.jpg?v=00d5c2783bef1593a27189a9cf198e1c",
    alt: "Urban Infra gated community villa plots Sarjapur Road",
    title: "Gated Community",
    project: "Urban Infra Projects",
    category: "Community",
    size: "normal",
  },
  {
    id: "g03",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/de429d81-f5d8-4150-b66a-617742fdd664_IMG-20260421-WA0022.jpg?v=f709d5faca9889278a53561b5ec4f532",
    alt: "Urban Infra project site development Bengaluru",
    title: "Project Site",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "normal",
  },
  {
    id: "g04",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b3591e3c-26fd-44b7-a7f2-7c113b2bb5f3_IMG-20260421-WA0016.jpg?v=9b56d07c97400179bfa1d297e26c7554",
    alt: "Wide roads in Urban Infra residential layout Sarjapur Road",
    title: "Wide Internal Roads",
    project: "Urban Infra Projects",
    category: "Roads",
    size: "wide",
  },
  {
    id: "g05",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/a6f7f289-d736-47a7-a889-74a69719c38a_IMG-20260421-WA0018.jpg?v=f0dd89476b1f2755bbf772b5023086f6",
    alt: "Green open spaces in Urban Infra gated community",
    title: "Green Open Spaces",
    project: "Urban Infra Projects",
    category: "Green Areas",
    size: "tall",
  },
  {
    id: "g06",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/2c641743-df69-4f45-934a-5276c66d89aa_IMG-20260421-WA0020.jpg?v=66b24ba626545c9d4017626497280d19",
    alt: "Urban Infra community development Sarjapur Road Bengaluru",
    title: "Community Development",
    project: "Urban Infra Projects",
    category: "Community",
    size: "normal",
  },
  {
    id: "g07",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/0eea5621-9288-476c-b93c-a5e068b9d124_IMG-20260421-WA0021.jpg?v=57dd8cdf8c5f00d90be7509a647c3f8b",
    alt: "Urban Infra villa plots layout on Sarjapur Road",
    title: "Villa Plots Layout",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "wide",
  },
  {
    id: "g08",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/585c3894-c097-453e-b992-91958f219026_IMG-20260421-WA0023.jpg?v=2a75a771db3dde0d41ca727fdc929d2d",
    alt: "Urban Infra road infrastructure residential layout Bengaluru",
    title: "Road Infrastructure",
    project: "Urban Infra Projects",
    category: "Roads",
    size: "normal",
  },
  {
    id: "g09",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/fa6dc448-6247-4326-887a-35f17df36bfa_IMG-20260421-WA0008.jpg?v=e48a74c009c28c5b8872ea045b6a348c",
    alt: "Urban Infra green landscape eco-friendly residential community",
    title: "Eco-Friendly Landscape",
    project: "Urban Infra Projects",
    category: "Green Areas",
    size: "normal",
  },
  {
    id: "g10",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/3d11c912-2cfa-4335-839c-6359a23d2bc0_IMG-20260421-WA00211.jpg?v=57dd8cdf8c5f00d90be7509a647c3f8b",
    alt: "Urban Infra premium gated community Sarjapur Road Bengaluru",
    title: "Premium Community",
    project: "Urban Infra Projects",
    category: "Community",
    size: "normal",
  },
  {
    id: "g11",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/89f1852b-dff4-4bbf-b437-3ff0fdcbce1b_IMG-20260421-WA0014.jpg?v=510b880227acaa0904d7ff3c0b616771",
    alt: "Urban Infra residential development site view",
    title: "Development Site",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "normal",
  },
  {
    id: "g12",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/fa57f257-af60-4dcd-b9e0-a158a7461584_IMG-20260421-WA0019.jpg?v=20d840bb7fe344734bb9559bfc3263c1",
    alt: "Urban Infra gated community entrance view",
    title: "Community Entrance",
    project: "Urban Infra Projects",
    category: "Community",
    size: "wide",
  },
  {
    id: "g13",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/93c9151d-f33e-46f3-897e-12ced6ecb498_IMG-20260421-WA0013.jpg?v=c0cfd604c63c6db8a9e22cf98b9ae93e",
    alt: "Urban Infra plot layout and planning",
    title: "Plot Layout",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "normal",
  },
  {
    id: "g14",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/0120c79f-79b5-43a9-bec6-47e1938af84c_IMG-20260421-WA0017.jpg?v=debaab7703ae5aeff74f2810847aad84",
    alt: "Urban Infra road and infrastructure development",
    title: "Infrastructure View",
    project: "Urban Infra Projects",
    category: "Roads",
    size: "normal",
  },
  {
    id: "g15",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/c3059863-b300-44bb-b4f4-27bf6ef80022_IMG-20260421-WA0015.jpg?v=ac6928b8565e2fa55e71c571a4d6fd42",
    alt: "Urban Infra green spaces and landscaping",
    title: "Landscaping",
    project: "Urban Infra Projects",
    category: "Green Areas",
    size: "tall",
  },
  {
    id: "g16",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/edea5b3a-47a0-4628-8b47-f549b9ea9597_IMG-20260421-WA0010.jpg?v=e390575b61624a9109953165deb8a566",
    alt: "Urban Infra residential community overview",
    title: "Community Overview",
    project: "Urban Infra Projects",
    category: "Community",
    size: "normal",
  },
  {
    id: "g17",
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/38d4fe3e-cb83-4cb9-a33f-65710f08f26e_IMG-20260421-WA0009.jpg?v=2fee54e345172558f9edf610278e0063",
    alt: "Urban Infra project development progress",
    title: "Development Progress",
    project: "Urban Infra Projects",
    category: "Layouts",
    size: "wide",
  },
];

export const galleryCategories: GalleryCategory[] = [
  "All",
  "Layouts",
  "Roads",
  "Green Areas",
  "Community",
];
